<template>
  <div id="app">
    <el-form
      v-loading="classload"
      :model="classinfo"
      :rules="rules"
      ref="classinfo"
      label-width="110px"
      size="medium"
    >
      <el-form-item class="course-tab">
        <el-tag
          size="medium"
          v-for="(item, index) in classList"
          :key="index"
          :closable="
            item.lessonSort != 1 &&
            item.lessonSort != classid &&
            index == classList.length - 1
          "
          :effect="item.lessonSort == classid ? 'dark' : 'plain'"
          @close="deleteLesson(item)"
          @click.native="chooseClass(item)"
          >第{{ index + 1 }}课时</el-tag
        >
        <el-button class="button-new-tag"  size="small" v-if="type == 2" @click="addClass"
          >+ 添加课时</el-button
        >
        <!-- <el-tag
          size="medium"
          v-for="(item, index) in classList"
          :key="index"
          :closable="
            item.lessonSort != 1 &&
            item.lessonSort != classid &&
            index == classList.length - 1
          "
          :effect="item.lessonSort == classid ? 'dark' : 'plain'"
          @close="deleteLesson(item)"
          @click.native="chooseClass(item)"
          >{{ item.lessonName }}</el-tag
        >
        <el-button class="button-new-tag" size="small" @click="addClass"
          >+ 添加课时</el-button
        > -->
      </el-form-item>
      <el-form-item label="课时名称：">
        <el-input
          style="width: 200px"
          v-for="(item, index) in classList"
          :key="index"
          v-show="item.lessonSort == classid"
          v-model="item.lessonName"
        ></el-input>
      </el-form-item>
      <div v-if="type == 1">
        <el-form-item label="直播时间：" prop="videoTime">
          <el-date-picker
            style="width: 180px"
            v-model="classinfo.stime"
            @change="timechange"
            type="datetime"
            size="small"
            placeholder="选择开始日期"
          ></el-date-picker>
          <span>至</span>
          <el-date-picker
            size="small"
            style="width: 180px"
            v-model="classinfo.etime"
            type="datetime"
            placeholder="选择结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="直播拉流地址：" v-if="classinfo.link !== ''">
          <el-input
            placeholder="请输入直播拉流地址"
            v-model="classinfo.link"
            size="small"
            clearable
            style="width: 378px"
          ></el-input>
        </el-form-item>
        <el-form-item label="直播推流地址：" v-if="getPushUrl !== ''">
          <el-input
            placeholder="请输入直播推流地址"
            v-model="getPushUrl"
            size="small"
            clearable
            style="width: 378px"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频来源：">
          <el-radio v-model="radio" :label="label1">本平台</el-radio>
          <el-radio v-model="radio" :label="label2">第三方</el-radio>
        </el-form-item>
        <el-form-item label="直播类型：" prop="room_type">
          <el-button
            round
            size="small"
            :type="item.code == classinfo.room_type ? 'primary' : ''"
            v-for="item in roomtype"
            :key="item.id"
            @click.native="chooseType1s(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
        <el-form-item label="直播状态：" prop="live_status">
          <el-button
            round
            :type="item.code == classinfo.live_status ? 'primary' : ''"
            v-for="item in livestatus"
            :key="item.id"
            size="small"
            @click.native="chooseType2s(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
        <el-form-item label="回放视频：">
          <el-button
            type="success"
            size="small"
            icon="el-icon-video-camera-solid"
            @click.native="chooseUploadTypes"
            >上传视频</el-button
          >
          <el-row
            class="upload-list"
            v-for="(item, index) in resultVideoList"
            :key="index"
          >
            <el-col class="upload-list-left">
              <a :href="serverHttp + item.url">
                <i class="el-icon-video-camera"></i>
                {{ item.originalFilename }}
              </a>
            </el-col>
            <el-col class="upload-list-right text-center" style="width: 130px">
              <span>{{ fanhuis(item.beginTime, item.endTime) }}</span>
            </el-col>
            <el-col
              class="upload-list-right text-center"
              style="width: 200px; text-align: right"
            >
              <span class="upload-btn-del" @click="bian(index)">编辑</span>
              <span class="upload-btn-del" @click="videoRemoves(index)"
                >删除</span
              >
              <a :href="serverHttp + item.url" class="upload-btn-down">下载</a>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="上传方式：">
          <el-button
            round
            size="small"
            :type="item.id == dtype ? 'primary' : ''"
            v-for="item in dtypeList"
            :key="item.id"
            @click.native="chooseDType(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
        <el-form-item v-if="dtype == 1" label="上传视频：">
          <el-upload
            :headers="headers"
            :action="uploadurl"
            :data="datas"
            accept="video/*"
            :limit="limit"
            :on-progress="progressUp1"
            :before-upload="beforeVideoUpload"
            :on-success="videoSuccess"
            :file-list="videoList"
          >
            <el-button
              type="success"
              size="small"
              icon="el-icon-video-camera-solid"
              >上传视频</el-button
            >
          </el-upload>
          <el-row
            class="upload-list"
            v-for="(item, index) in resultVideoList"
            :key="index"
          >
            <el-col class="upload-list-left">
              <a :href="serverHttp + item.url">
                <i class="el-icon-video-camera"></i>
                {{ item.originalFilename }}
              </a>
            </el-col>
            <el-col class="upload-list-right text-center">
              <span>课程视频</span>
            </el-col>
            <el-col class="upload-list-right text-center">
              <span>{{ item.time }}</span>
            </el-col>
            <el-col class="upload-list-right text-center">
              <span class="upload-btn-del" @click="videoRemove">删除</span>
              <a :href="serverHttp + item.url" class="upload-btn-down">下载</a>
            </el-col>
          </el-row>
        </el-form-item>
        <div v-else>
          <el-form-item label="MD5值：">
            <el-input
              size="small"
              :disabled="videoDisabled"
              placeholder="请输入MD5值"
              v-model="classinfo.videomd5"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="视频名称：">
            <el-input
              :disabled="videoDisabled"
              size="small"
              placeholder="请输入视频名称"
              v-model="classinfo.videoname"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="视频地址：">
            <el-input
              :disabled="videoDisabled"
              size="small"
              placeholder="请输入视频地址"
              v-model="classinfo.videosrc"
              clearable
              style="width: 300px"
            ></el-input>
            <el-button size="small" @click="ossSelect" type="primary"
              >选取视频</el-button
            >
          </el-form-item>
        </div>
      </div>
      <el-form-item label="是否试看：" v-show="false">
        <el-tooltip
          :content="classinfo.lessonLimit == '0' ? '不试看' : '试看'"
          placement="top"
        >
          <el-switch
            v-model="classinfo.lessonLimit"
            active-color="#409EFF"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="权限：" prop="home" v-show="false">
        <span class="permissions"
          >开放评论：
          <el-tooltip
            :content="classinfo.commentsIsOpen == '0' ? '不开放' : '开放'"
            placement="top"
          >
            <el-switch
              v-model="classinfo.commentsIsOpen"
              active-color="#409EFF"
              active-value="1"
              inactive-value="0"
            ></el-switch> </el-tooltip
        ></span>
        <span class="permissions">
          观众列表：
          <el-tooltip
            :content="classinfo.spectatorIsOpen == '0' ? '不开放' : '开放'"
            placement="top"
          >
            <el-switch
              v-model="classinfo.spectatorIsOpen"
              active-color="#409EFF"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </el-tooltip>
        </span>
        <span class="permissions">
          游客评论：
          <el-tooltip
            :content="classinfo.visitorIsOpen == '0' ? '不开放' : '开放'"
            placement="top"
          >
            <el-switch
              v-model="classinfo.visitorIsOpen"
              active-color="#409EFF"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </el-tooltip>
        </span>
      </el-form-item>
      <el-form-item label="课程资源：">
        <el-upload
          :headers="headers"
          :action="uploadurl"
          :data="datas"
          :accept="filetype"
          :before-upload="beforeFileUpload"
          :on-success="fileSuccess"
          :show-file-list="true"
          :file-list="fileList"
        >
          <el-button
            type="success"
            size="small"
            v-for="item in fileTypeList"
            :key="item.restypeId"
            icon="el-icon-upload"
            @click.native="chooseUploadType(item)"
            >{{ item.restypeName }}</el-button
          >
        </el-upload>
        <el-row
          class="upload-list"
          v-for="(item, index) in resultList"
          :key="index"
        >
          <el-col class="upload-list-left">
            <a :href="serverHttp + item.url">
              <i class="el-icon-s-management"></i>
              {{ item.originalFilename }}
            </a>
          </el-col>
          <el-col class="upload-list-right text-center">
            <span>{{ item.resTypeName }}</span>
          </el-col>
          <el-col class="upload-list-right text-center">
            <span>{{ item.time }}</span>
          </el-col>
          <el-col class="upload-list-right text-center">
            <span class="upload-btn-del" @click="fileRemove(index)">删除</span>
            <a :href="serverHttp + item.url" class="upload-btn-down">下载</a>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item class="class-save">
        <el-button
          size="small"
          type="primary"
          @click.native="saveCourseLesson('classinfo')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog :title="titles" :visible.sync="dialogVisible" width="1050px">
      <el-form :model="form" :rules="formrules" ref="form" label-width="120px">
        <el-form-item label="时间段：" prop="videoTime">
          <el-date-picker
            style="width: 180px"
            size="small"
            v-model="form.beginTime"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始日期"
          ></el-date-picker>
          <span>至</span>
          <el-date-picker
            size="small"
            style="width: 180px"
            v-model="form.endTime"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="名称：" prop="videoTitle">
          <el-input
            size="small"
            placeholder="请输入课程名称"
            v-model="form.videoTitle"
            clearable
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="回放视频：">
          <el-upload
            :headers="headers"
            :action="uploadurl"
            accept="video/*"
            :limit="limit"
            :on-progress="progressUp"
            :before-upload="beforeVideoUploads"
            :on-success="videoSuccess1"
            :file-list="videoList"
            :data="datas"
          >
            <el-button
              type="success"
              size="small"
              icon="el-icon-video-camera-solid"
              @click.native="chooseUploadType"
              >上传视频</el-button
            >
          </el-upload>
          <el-row
            class="upload-list"
            v-for="(item, index) in resultVideoL"
            :key="index"
          >
            <el-col class="upload-list-left">
              <a :href="serverHttp + item.url">
                <i class="el-icon-video-camera"></i>
                {{ item.originalFilename }}
              </a>
            </el-col>
            <el-col class="upload-list-right text-center">
              <span>课程视频</span>
            </el-col>
            <el-col class="upload-list-right text-center" style="width: 60px">
              <!-- <span>{{item.time}}</span> -->
            </el-col>
            <el-col
              class="upload-list-right text-center"
              style="width: 200px; text-align: right"
            >
              <!-- <span class="upload-btn-del" @click="bian(index)">编辑</span> -->
              <span class="upload-btn-del" @click="videoRemoves1(index)"
                >删除</span
              >
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="resetFormsf('form')" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- oss视频选取 -->
    <!-- :before-close="ossClose" -->
    <el-dialog title="OSS资源选取" :visible.sync="ossDialog" width="900px">
      <div>
        <span
          @click="topUrl(item)"
          class="url_click"
          :class="{url_click_c:index > 0}"
          v-for="(item, index) in ossUrl"
          :key="index"
          >{{ item }}</span
        >
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-bottom: 15px">
          <el-input
            size="small"
            v-model="prefix"
            placeholder="按名称前缀过滤"
            @keyup.enter.native="queryVideoList"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px">
          <el-button size="small" type="primary" @click="queryOss"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item style="margin-bottom: 15px">
          <el-form-item class="class-save">
            <el-button-group>
              <el-button
                @click="queryVideoList('marker')"
                :disabled="!marker"
                size="small"
                type="primary"
                icon="el-icon-arrow-left"
                >上一页</el-button
              >
              <el-button
                @click="queryVideoList('nextMarker')"
                :disabled="!nextMarker"
                size="small"
                type="primary"
                >下一页<i class="el-icon-arrow-right el-icon--right"></i
              ></el-button>
            </el-button-group>
          </el-form-item>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px">
          <el-link
            href="https://mxjj-evaluate-online-live.oss-cn-beijing.aliyuncs.com/template/ossbrowser.docx?versionId=CAEQIhiBgMDhl5nK3xciIGJiNTA3ZjVkYTAyYjRmNDhhOGVkMjYxMzljMzM4MTFi"
            type="primary"
            :underline="false"
            >oss视频上传工具下载</el-link
          >
        </el-form-item>
      </el-form>
      <el-table
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        :data="videoOssList"
        stripe
        @row-dblclick="rowClick"
        style="width: 100%"
      >
        <el-table-column label="名称" prop="path">
          <template slot-scope="scope">
            <i
              style="color: #ffd04b"
              v-if="scope.row.isDir == 1"
              class="el-icon-folder"
            ></i>
            <i v-else class="el-icon-document"></i>
            {{ scope.row.path }}
          </template>
        </el-table-column>
        <el-table-column label="类型/大小" align="left" width="180">
          <template slot-scope="scope">
            {{ scope.row.isDir == 1 ? "目录" : "资源"
            }}{{ scope.row.formattedSize ? "/" + scope.row.formattedSize : "" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isDir !== 1"
              size="small"
              @click="selectvideo(scope.row)"
              type="text"
              >选取</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK, BASE_URLLIST } from "@/api/index";
//加密解密
import utils from "@/api/utils";
//日期格式化
import moment from "moment";
export default {
  data() {
    let vBookName = (rule, value, callback) => {
      if (this.book === "") {
        callback(new Error("请选择教材"));
      } else {
        callback();
      }
    };
    //视频地址
    let videoLink = (rule, value, callback) => {
      //直播
      if (this.type == 1) {
        if (this.classinfo.link == "") {
          callback(new Error("请输入直播拉流地址"));
        } else {
          // //正则验证网址
          // const reg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
          // if (!reg.test(this.classinfo.link)) {
          //   callback(new Error('请输入合法的直播推流地址'))
          // } else {
          //   callback()
          // }
          callback();
        }
      } else {
        callback();
      }
    };
    //直播时间
    let videoTime = (rule, value, callback) => {
      //直播验证
      if (this.type == 1) {
        //直播时间
        if (!this.classinfo.stime) {
          callback(new Error("请选择开始时间"));
        } else if (!this.classinfo.etime) {
          callback(new Error("请选择结束时间"));
        } else {
          //开始时间
          let stime = Date.parse(this.classinfo.stime);
          //结束时间
          let etime = Date.parse(this.classinfo.etime);
          if (stime > etime) {
            callback(new Error("开始时间不能大于结束时间"));
          } else {
            callback();
          }
        }
      } else {
        //点播不验证
        callback();
      }
    };
    let videoTimes = (rule, value, callback) => {
      //直播验证
      if (this.type == 1) {
        //直播时间
        if (!this.form.beginTime) {
          callback(new Error("请选择开始时间"));
        } else if (!this.form.endTime) {
          callback(new Error("请选择结束时间"));
        } else {
          callback();
        }
      } else {
        //点播不验证
        callback();
      }
    };
    return {
      flag: 0,
      groupId: localStorage.getItem("groupId"),
      classload: false, //课时保存
      serverHttp: "", //主机地址
      roomtype: [],
      livestatus: [],
      radio: 1,
      label1: 1,
      label2: 2,
      form: {
        beginTime: "",
        endTime: "",
        videoTime: "",
        videoTitle: "",
      },
      bianint: -1,
      titles: "",
      resultVideoL: [],
      datas: {
        bucketId: 1,
      },
      dialogVisible: false, //视频添加
      getPushUrl: "", //直播推流地址
      limit: 1, //上传视频个数
      classList: [{ lessonSort: 1, lessonName: "第1课时" }], //课时列表
      classid: 1, //选中课时
      classinfo: {
        id: 0, //课时id
        stime: "", //开始日期
        etime: "", //结束日期
        link: "", //直播推流地址
        videolink: "", //视频地址
        videomd5: "", //视频md5值
        videoname: "", //视频名称
        videosrc: "", //视频输入地址
        room_type: "",
        live_status: "2",
        lessonLimit: "0",
        commentsIsOpen: "0", // 开放评论
        spectatorIsOpen: "0", //观众列表
        visitorIsOpen: "0", //游客是否能够评论
      }, //课时信息
      room: [
        { id: 1, name: "云直播" },
        { id: 2, name: "云课堂（小班课）" },
        { id: 3, name: "互动直播" },
        { id: 4, name: "空中课堂" },
      ],
      roomtyps: 1,
      headers: {
        token: localStorage.getItem("token"), //文件上传请求头
      },
      dtypeList: [
        { id: 1, name: "上传视频" },
        { id: 2, name: "从OSS选取" },
      ], //视频上传方式
      dtype: 1, //上传方式
      classid: 1, //课时
      videoList: [], //视频列表
      resultVideoList: [], //最终视频列表
      filetypes: [], //上传类型列表
      fileTypeList: [], //上传资源类型
      filetypeid: 0, //上传类型ID
      filetype: "", //默认类型
      fileList: [], //资源列表
      resultList: [], //最终资源列表
      loading: false, //上传状态
      uploadurl: homeApi.uplUrl + "/file/oss-upload", //上传图片地址
      loadings: "",
      loadingsd: "",
      types: -1,
      formrules: {
        videoTitle: [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
      },
      rules: {
        schoolName: [
          { required: true, message: "请选择直播学校", trigger: "blur" },
        ],
        live_status: [
          { required: true, message: "请选择直播状态", trigger: "blur" },
        ],
        types: [{ required: true, message: "请选择课程分类", trigger: "blur" }],
        courseLimit: [
          {
            required: true,
            message: "请选择公开范围",
            trigger: "blur",
          },
        ],
        courseSpeaker: [
          { required: true, message: "请选择主讲人", trigger: "blur" },
        ],
        bookName: [{ required: true, validator: vBookName, trigger: "change" }],
        chapterName: [
          { required: true, message: "请选择章节", trigger: "blur" },
        ],
        link: [{ required: true, validator: videoLink, trigger: "blur" }],
        room_type: [
          { required: true, message: "请选择直播类型", trigger: "blur" },
        ],
        videoTime: [
          {
            type: "date",
            required: true,
            validator: videoTime,
            trigger: "change",
          },
        ],
        roomtyps: [
          { required: true, message: "请选择直播分类", trigger: "blur" },
        ],
      },
      videoOssList: [],
      ossDialog: false,
      prefix: "",
      ossUrl: ["ahsy/"],
      marker: "",
      nextMarker: "",
      videoDisabled: false,
      pageArr: [],
    };
  },
  props: {
    type: {
      type: [Number, String],
      required: true,
    },
    courseId: {
      type: [Number, String],
      required: true,
    },
    courseName: {
      type: String,
    },
  },
  created() {
    this.dictcode2();
    this.dictcode1();
    this.getResTypeList();
    this.flag = this.$route.query.id;
    if (!!this.flag) {
      this.getCourseInfo();
    }
  },
  methods: {
    topUrl(url) {
      let idx = this.ossUrl.indexOf(url) + 1;
      if (!!this.ossUrl[idx]) {
        this.ossUrl.splice(idx, this.ossUrl.length);
        this.pageArr = [];
        this.queryVideoList();
      }
    },
    queryOss() {
      console.log(this.ossUrl);
      this.pageArr = [];
      this.queryVideoList(-1);
    },
    ossSelect() {
      this.queryVideoList();
      this.ossDialog = true;
    },
    // 单行双击
    rowClick(row) {
      let idx = row.name.indexOf(this.prefix);
      if (idx == -1) {
        this.ossUrl.push(this.prefix + row.name);
      } else {
        this.ossUrl.push(row.name);
      }
      this.prefix = "";
      this.pageArr = [];
      this.queryVideoList();
    },
    // 获取视频目录
    queryVideoList(state) {
      let url = "";
      this.ossUrl.forEach((item) => {
        url = url + item;
      });
      if (state == -1) {
        url = url + this.prefix;
      }
      let params = {
        bucketType: "live",
        prefix: url,
      };
      let len = this.pageArr.length;
      if (state == "nextMarker") {
        params.marker = this.nextMarker;
        this.pageArr.push(this.nextMarker);
      }
      if (state == "marker") {
        if (len == 1) {
          params.marker = null;
        } else {
          params.marker = this.pageArr[len - 2];
        }
        this.pageArr.splice(len - 1, 1);
      }
      homeApi.queryVideoList(params).then((res) => {
        if (res.data.code == 0) {
          this.videoOssList = res.data.data.objectList;
          this.marker = res.data.data.marker;
          this.nextMarker = res.data.data.nextMarker;
        }
      });
    },
    selectvideo(info) {
      this.classinfo.videosrc = info.path;
      this.classinfo.videoname = info.name;
      this.classinfo.videomd5 = this.$md5(info.url);

      this.videoDisabled = true;
      this.ossDialog = false;
    },
    // 点播视屏上传之前
    progressUp1(event) {
      this.loadingsd = this.$loading({
        lock: true,
        text: "视频上传至服务器中，请稍后。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // if (event.loaded == event.total) {
      //   this.loadingsd = this.$loading({
      //     lock: true,
      //     text: "视频上传至服务器中，请稍后。。。",
      //     spinner: "el-icon-loading",
      //     background: "rgba(0, 0, 0, 0.7)",
      //   });
      // }
    },
    // 回放视屏上传之前
    progressUp(event) {
      // console.log('event',event);
      this.loadings = this.$loading({
        lock: true,
        text: "视频上传至服务器中，请稍后。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // if (event.loaded == event.total) {
      //   this.loadings = this.$loading({
      //     lock: true,
      //     text: "视频上传至服务器中，请稍后。。。",
      //     spinner: "el-icon-loading",
      //     background: "rgba(0, 0, 0, 0.7)",
      //   });
      // }
    },
    //获取课程详情
    getCourseInfo() {
      if (this.courseId > 0) {
        //参数
        let params = {
          id: this.courseId,
        };
        //开启加载
        this.courseload = true;
        this.classload = true;
        let _this = this;
        //接口
        homeApi
          .getCourseInfo(params)
          .then((res) => {
            //关闭加载
            _this.courseload = false;
            _this.classload = false;
            let { data } = res;

            if (data.code === ERR_OK) {
              let info = data.data;
              if (info) {
                //课时列表
                let clist = info.lessonVos;
                _this.serverHttp = info.serverHttp;
                _this.getPushUrl = clist[0].rtmpUrl;
                _this.radio = clist[0].videoSource;
                _this.type = info.courseTypeid;
                if (clist.length > 0) {
                  //课时升序排列
                  clist = info.lessonVos.sort(
                    (a, b) => a.lessonSort - b.lessonSort
                  );
                  _this.classList = clist;
                  //更新课时名称
                  // _this.classList.forEach((res) => {
                  //   let name = "第" + res.lessonSort + "课时";
                  //   res.lessonName = name;
                  // });

                  //默认第一课时
                  _this.resetClass();
                  let cinfo = clist[_this.classid - 1];
                  //获取课时详情
                  _this.initClass(cinfo);
                }
              }
            }
          })
          .catch((error) => {
            //关闭加载
            _this.courseload = false;
            _this.classload = false;
            console.log(error);
          });
      }
    },
    // 获取课时详情
    getCourseInfos() {},
    // 数据处理
    fanhuis(s, d) {
      if (s !== "" && d !== "") {
        return s.slice(10, 16) + " -" + d.slice(10, 16);
      }
    },
    //删除课时
    deleteLesson(v) {
      let sort = v.lessonSort;
      let text = "第" + sort + "课时";
      this.$confirm("确认删除 【" + text + "】么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //参数
          let prarms = {
            id: v.lessonId,
          };
          let _this = this;
          this.classload = true;
          //接口
          homeApi
            .deleteLesson(prarms)
            .then((res) => {
              let { data } = res;
              _this.classload = false;
              if (data.code === ERR_OK) {
                _this.classList.splice(sort - 1, 1);
                // _this.$toast.center("删除课时成功");
              }
            })
            .catch((error) => {
              _this.classload = false;
              _this.classList.splice(sort - 1, 1);
              // _this.$toast.center("删除课时成功");
              console.log(error);
            });
        })
        .catch(() => {});
    },
    //选择课时
    chooseClass(v) {
      this.classid = v.lessonSort;
    },
    //添加课时
    addClass() {
      //新增ID
      let num = this.classList.length + 1;
      let name = "第" + num + "课时";
      let list = { lessonSort: num, lessonName: name };
      this.classList.push(list);
      //选择新增课时
      this.classid = num;
      this.resetClass();
    },
    //获取课时详情
    initClass(v) {
      //  this.lessongetPushUrl(data.data);
      if (v) {
        this.classinfo.id = v.lessonId; //课时ID
        this.classid = v.lessonSort; //课时选择
        this.classinfo.stime = v.beginTime; //开始时间
        this.classinfo.etime = v.endTime; //开始时间
        this.classinfo.link = v.rtmpUrl; //推流地址
        this.classinfo.room_type = v.roomType;
        this.classinfo.live_status = v.liveStatus;
        this.classinfo.lessonLimit = String(v.lessonLimit || 0);
        this.classinfo.commentsIsOpen = String(v.commentsIsOpen || 0); //评论列表
        this.classinfo.spectatorIsOpen = String(v.spectatorIsOpen || 0); //观众列表
        this.classinfo.visitorIsOpen = String(v.visitorIsOpen || 0); //游客是否能够评论
        let zylist = [];
        this.lessongetPushUrl(v.lessonId);
        //资源文件
        if (!!this.flag) {
          if (this.type == 1) {
            zylist = v.videoVoList;
            this.resultVideoList = this.uploadFileToList(zylist);
          } else {
            if (!!v.fileModel) zylist.push(v.fileModel);
            this.resultVideoList = this.uploadFileToList(zylist);
          }
        } else {
          if (this.types == 1) {
            zylist = v.videoVoList;
            this.resultVideoList = this.uploadFileToList(zylist);
          } else {
            zylist.push(v.fileModel);
            this.resultVideoList = this.uploadFileToList(zylist);
          }
        }

        //手动录入
        if (zylist.length > 0) {
          let fmodel = this.resultVideoList[0];
          this.classinfo.videomd5 = fmodel.md5;
          this.classinfo.videoname = fmodel.originalFilename;
          this.classinfo.videosrc = fmodel.url;
        }

        //备课列表
        let bklist = v.resPubVos ? v.resPubVos : [];

        this.resultList = this.uploadFileToList(bklist);
      } else {
        this.classid = 1; //课时选择
      }
    },
    //资源文件列表转显示列表
    uploadFileToList(v) {
      let list = [];
      if (v && v.length > 0) {
        v.forEach((res) => {
          let clist = {
            fileName: res.fileUrl,
            originalFilename: res.fileName,
            fileNameSuffix: res.fileFormat,
            url: res.fileUrl,
            size: res.fileSize,
            md5: res.md5,
            beginTime: res.beginTime,
            endTime: res.endTime,
            videoTitle: res.videoTitle,
          };
          //资源类型ID
          if (res.restypeId > 0) {
            clist.restypeId = res.restypeId;
          }
          //资源名称
          if (res.resTypeName) {
            clist.resTypeName = res.resTypeName;
          }
          list.push(clist);
        });
      }
      return list;
    },
    // 直播类型变化
    chooseType1s(v) {
      this.classinfo.room_type = v.code;
    },
    chooseType2s(v) {
      this.classinfo.live_status = v.code;
    },
    // 获取直播类型
    dictcode1() {
      let that = this;
      let params = {
        code: "room_type",
      };
      //接口
      homeApi
        .dictcode(params)
        .then((res) => {
          that.roomtype = res.data.data;
        })
        .catch((error) => {});
    },
    // 获取直播状态
    dictcode2() {
      let that = this;
      let params = {
        code: "live_status",
      };
      //接口
      homeApi
        .dictcode(params)
        .then((res) => {
          that.livestatus = res.data.data;
        })
        .catch((error) => {});
    },
    // 判断视频格式和数量
    beforeVideoUploads(file) {
      //判断是否为视频格式
      const isVideo = file.type.indexOf("video");
      if (isVideo < 0) {
        this.$toast.center("只能上传视频格式");
      }
      if (this.resultVideoL.length > 0) {
        this.$toast.center("只能上传一个，请删除后重新上传！");
        return false;
      }
      return isVideo;
    },
    //视频开始上传前 判断视频格式和数量
    beforeVideoUpload(file) {
      //判断是否为视频格式
      const isVideo = file.type.indexOf("video");
      if (isVideo < 0) {
        this.$toast.center("只能上传视频格式");
      }
      return isVideo;
    },
    // 回放视频上传成功
    videoSuccess1(file, data, list) {
      this.loadings.close();
      this.$message({
        message: "视频上传成功",
        type: "success",
      });
      // this.videoRemove()
      this.videoList = [];
      let vlist = [];
      file.data.forEach((res) => {
        res.url = res.fileName;
        vlist.push(res);
      });
      this.resultVideoL = vlist;
    },
    //视频上传成功
    videoSuccess(file, data, list) {
      this.videoRemove();
      this.loadingsd.close();
      this.$message({
        message: "视频上传成功",
        type: "success",
      });
      this.videoList = [];
      let vlist = this.resultVideoList;
      file.data.forEach((res) => {
        res.url = res.fileName;
        vlist.push(res);
      });
      this.resultVideoList = vlist;
      if (this.courseId != 0) {
        this.saveCourseLesson("classinfo", 1);
      }
    },
    // 回放视频上传
    chooseUploadTypes(v) {
      if (this.type == 1) {
        this.dialogVisible = true;
        this.titles = "上传视频";
        this.resultVideoL = [];
        this.form.endTime = "";
        this.form.beginTime = "";
        this.bianint = -1;
      }
      //资源类型ID
      this.filetypeid = v.restypeId;
      //上传格式
      this.filetype = "";
      //允许上传格式
      if (v.restypeMime) {
        let strfile = "";
        this.filetypes = [];
        let exts = v.restypeMime.split(",");
        exts.forEach((res) => {
          let list = utils.getUploadType(res);
          strfile += list.name + ",";
          this.filetypes.push(list);
        });
        strfile =
          strfile != "" ? strfile.substring(0, strfile.length - 1) : strfile;
        this.filetype = strfile;
      }
    },
    // 上传视频
    resetFormsf(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.form.beginTime == "" || that.form.endTime == "") {
            this.$toast.center("请选择时间段");
            return false;
          } else if (that.resultVideoL.length == 0) {
            this.$toast.center("请上传回放视频");
            return false;
          } else {
            that.resultVideoL[0].beginTime = that.form.beginTime;
            that.resultVideoL[0].endTime = that.form.endTime;
            that.resultVideoL[0].videoTitle = that.form.videoTitle;
            if (that.bianint >= 0) {
              that.resultVideoList[that.bianint] = that.resultVideoL[0];
              //  that.resultVideoList.push(that.resultVideoL[0])
            } else {
              that.resultVideoList.push(that.resultVideoL[0]);
            }
            that.dialogVisible = false;
          }
        } else {
          return false;
        }
      });
    },
    // 编辑视频
    bian(s) {
      this.dialogVisible = true;
      this.titles = "编辑视频";
      this.bianint = s;
      this.dialogVisible = true;
      this.form.endTime = this.resultVideoList[s].endTime;
      this.form.beginTime = this.resultVideoList[s].beginTime;
      this.form.videoTitle = this.resultVideoList[s].videoTitle;
      this.resultVideoL[0] = this.resultVideoList[s];
    },
    //选择上传方式
    chooseDType(v) {
      this.dtype = v.id;
    },
    //视频删除
    videoRemove() {
      this.videoList = [];
      this.resultVideoList = [];
    },
    // 回放视频删除
    videoRemoves(s) {
      let list = [];
      for (var i = 0; i < this.resultVideoList.length; i++) {
        if (i !== s) {
          list.push(this.resultVideoList[i]);
        }
      }
      this.videoList = list;
      this.resultVideoList = list;
    },
    // 优客视频删除
    videoRemoves1() {
      this.videoList = [];
      this.resultVideoL = [];
    },
    //选择上传类型
    chooseUploadType(v) {
      //资源类型ID
      this.filetypeid = v.restypeId;
      //上传格式
      this.filetype = "";
      //允许上传格式
      if (v.restypeMime) {
        let strfile = "";
        this.filetypes = [];
        let exts = v.restypeMime.split(",");
        exts.forEach((res) => {
          let list = utils.getUploadType(res);
          console.log(res);
          strfile += list.name + ",";
          this.filetypes.push(list);
        });
        strfile =
          strfile != "" ? strfile.substring(0, strfile.length - 1) : strfile;
        this.filetype = strfile;
      }
    },
    //上传文件之前
    beforeFileUpload(file) {
      //是否为上传格式
      let isfile = false;
      //提示信息
      let strMsg = "";
      this.filetypes.forEach((res) => {
        console.log(file.type);
        if (res.name == file.type) {
          isfile = true;
        }
        if (res.name == "audio/mpeg") {
          isfile = true;
        }
        console.log(this.filetypes);
        strMsg += res.id + ",";
      });
      console.log(strMsg);
      strMsg = strMsg != "" ? strMsg.substring(0, strMsg.length - 1) : strMsg;
      //文件格式验证
      if (!isfile) {
        this.$toast.center("只能上传" + strMsg + "格式文件");
      }
      return isfile;
    },
    //时间戳转日期格式
    dateFormat(data, keyStr) {
      return moment(new Date(data)).format(keyStr);
    },
    //获取上传资源类型
    getResTypeList() {
      //参数
      let params = {
        schoolId: this.groupId,
        restypeBelong: 2,
      };
      let _this = this;
      //接口
      homeApi
        .getResTypeList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取上传资源类型
            _this.fileTypeList = list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //文件上传成功
    fileSuccess(file, data, list) {
      //清除文件列表
      this.fileList = [];
      //自定义文件列表
      let clist = file.data[0];
      clist.url = clist.fileName; //文件名称
      clist.time = this.dateFormat(file.times, "YYYY-MM-DD"); //上传日期
      clist.restypeId = this.filetypeid > 0 ? this.filetypeid : 0; //上传资源类型
      clist.resTypeName = this.fileTypeList.find(
        (res) => res.restypeId == this.filetypeid
      ).restypeName; //资源类型
      this.resultList.push(clist);
    },
    //文件删除
    fileRemove(i) {
      this.resultList.splice(i, 1);
    },
    //课程详情-根据课时ID获取推流地址
    lessongetPushUrl(s) {
      let that = this;
      let params = {
        lessonId: s,
      };
      //接口
      homeApi
        .lessongetPushUrl(params)
        .then((res) => {
          that.getPushUrl = res.data.data;
        })
        .catch((error) => {});
    },
    timechange() {
      console.log("this.classinfo.etime", this.classinfo.etime);
    },
    //保存课时
    saveCourseLesson(formName, status = 0) {
      this.$refs.classinfo.validate((valid) => {
        if (valid) {
          //参数
          let params = {
            lessonId: this.classinfo.id, //课时ID
            lessonSort: this.classid, //课时序号
            roleType: "operate", //角色运营
          };
          //有课程才能添加课时
          if (this.courseId == 0) {
            // this.$toast.center("课程不存在，请先添加课程");
            this.$message.error("课程不存在，请先添加课程");
            return;
          } else {
            params.courseId = this.courseId;
          }
          //课时名称
          params.lessonName = this.classList.find(
            (res) => res.lessonSort == this.classid
          ).lessonName; //课时名称
          //直播类型
          if (this.type == 1) {
            params.roomType = this.classinfo.room_type;
            //转换日期格式
            params.beginTime = utils.formatDateTime(this.classinfo.stime); //开始时间
            params.endTime = utils.formatDateTime(this.classinfo.etime); //结束时间
            params.rtmpUrl = this.classinfo.link; //直播推流地址
            params.liveStatus = this.classinfo.live_status;
            // let fileModel = this.resultVideoList //直播文件
            //直播文件
            if (this.resultVideoList.length > 0) {
              // params.md5 = fileModel.md5 //直播文件md5
              //视频文件
              params.videoVoList = [];
              for (var i = 0; i < this.resultVideoList.length; i++) {
                // let Format=fileModel[i].fileNameSuffix.substring(fileModel[i].fileNameSuffix.indexOf('.') + 1)
                let videofile = {
                  md5: this.resultVideoList[i].md5,
                  // fileUrl: fileModel.url,
                  fileSize: this.resultVideoList[i].size,
                  fileName: this.resultVideoList[i].originalFilename,
                  fileFormat: this.resultVideoList[i].fileNameSuffix,
                  fileUrl: this.resultVideoList[i].fileName,
                  endTime: this.resultVideoList[i].endTime,
                  beginTime: this.resultVideoList[i].beginTime,
                  videoTitle: this.resultVideoList[i].videoTitle,
                };
                console.log(videofile);
                params.videoVoList.push(videofile); //直播文件
              }
              // params.videoVoList = videofile //直播文件
            }
          } else {
            if (this.dtype == 1) {
              let fileModel = this.resultVideoList[0]; //直播文件
              //直播文件
              if (fileModel) {
                params.md5 = fileModel.md5; //直播文件md5
                //视频文件
                let Format = fileModel.fileNameSuffix.substring(
                  fileModel.fileNameSuffix.indexOf(".") + 1
                );
                let videofile = {
                  md5: fileModel.md5,
                  fileUrl: fileModel.url,
                  fileSize: fileModel.size,
                  fileName: fileModel.originalFilename,
                  fileFormat: Format,
                };
                params.fileModel = videofile; //直播文件
              }
            } else {
              params.md5 = this.classinfo.videomd5; //手动录入MD5

              //视频文件
              let videofile = {
                md5: this.classinfo.videomd5,
                fileUrl: this.classinfo.videosrc,
                fileSize: 0,
                fileName: this.classinfo.videoname,
                fileFormat: "",
              };
              //文件后缀
              let suffix = this.classinfo.videoname;
              if (suffix.indexOf(".") != -1) {
                videofile.fileFormat = suffix.substring(
                  suffix.indexOf(".") + 1
                );
              }
              params.fileModel = videofile; //直播文件
            }
          }
          params.lessonLimit = parseInt(this.classinfo.lessonLimit);
          //添加人信息
          if (this.userinfo) {
            params.userId = this.userinfo.id; //用户ID
            params.userName = this.userinfo.name; //用户名
          }
          params.videoSource = this.radio;
          //备课资源列表
          if (this.resultList.length > 0) {
            let filelist = [];
            this.resultList.forEach((res) => {
              let file = {
                restypeId: res.restypeId, //资源类型ID
                md5: res.md5, //MD5
                fileUrl: res.url, //上传地址
                fileSize: res.size, //上传大小
                fileName: res.originalFilename, //原文件名
                fileFormat: res.fileNameSuffix, //文件格式
              };
              filelist.push(file);
            });
            params.resPubVos = filelist; //上传资源列表
          }

          // console.log(params);
          // console.log(this.classinfo.commentsIsOpen);
          params.commentsIsOpen = this.classinfo.commentsIsOpen || "0";
          params.spectatorIsOpen = this.classinfo.spectatorIsOpen || "0";
          params.visitorIsOpen = this.classinfo.visitorIsOpen || "0";
          // return;
          //提示加载
          this.classload = true;
          let _this = this;
          //接口
          homeApi
            .saveCourseLesson(params)
            .then((res) => {
              let { data } = res;
              _this.classload = false;
              if (data.code === ERR_OK) {
                //提示信息

                let msg =
                  _this.classinfo.id > 0 ? "编辑课时成功" : "添加课时成功";
                if (status !== 1) {
                  _this.$message({
                    message: msg,
                    type: "success",
                  });
                }

                if (_this.type == 1) {
                  _this.lessongetPushUrl(data.data);
                  // _this.getCourseInfo()
                }
                // 更新课时列表
                _this.getCourseInfo();
              } else {
                _this.$message.error(data.msg);
              }
            })
            .catch((error) => {
              _this.classload = false;
            });
        } else {
          return false;
        }
      });
    },
    // 继续添加
    tiansj() {
      this.courseId = 0;
      this.classinfo.etime = "";
      this.classinfo.stime = "";
      this.classinfo.link = "";
      this.resultVideoList = [];
      this.classinfo.id = "";
      this.resetClass();
      this.$message({
        message: "操作成功,请继续添加",
        type: "success",
      });
    },
    //课时初始化
    resetClass() {
      //表单重置
      // this.$refs["classinfo"].resetFields();
      //课程相关初始化
      this.videoList = [];
      this.resultVideoList = [];
      this.fileList = [];
      this.resultList = [];
      this.filetypes = [];
      this.filetypeid = 0;
      this.filetype = "";
      //初始化视频上传
      this.classinfo.videomd5 = "";
      this.classinfo.videoname = "";
      this.classinfo.videosrc = "";
      this.classinfo.room_type = "";
      this.classinfo.commentsIsOpen = "0";
      this.classinfo.spectatorIsOpen = "0";
      this.classinfo.visitorIsOpen = "0";
    },
    //如果是直播只能选择一个课时
    changeAddClass(id){
        if(id==1){
           //直播
           this.classList=[{ lessonSort: 1, lessonName: "第1课时" }]
        }else{
          //点播
        }
    }
  },
  watch: {
    //课时ID
    classid(v) {
      this.$nextTick(() => {
        //初始化课时内容
        this.resetClass();
        //获取课时内容
        let info = this.classList[v - 1];
        if (info) {
          this.initClass(info);
        }
      });
    },
    courseName() {
      this.classList[0].lessonName = this.courseName;
    },
  },
};
</script>
<style scoped>
.course-tab {
  font-family: "PingFang SC";
}
.course-tab .el-form-item__content .el-tag {
  cursor: pointer;
  margin-right: -5px;
  min-width: 90px;
  text-align: center;
}
.course-tab .el-tag .el-icon-close {
  position: relative;
  top: 0px;
}
.button-new-tag {
  height: 28px;
  line-height: 28px;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  border: 1px dashed #b3d8ff;
  border-left: 1px solid #b3d8ff;
  position: relative;
  top: 1px;
}
.upload-list {
  width: 800px;
  background: #ecf5ff;
  margin-top: 10px;
  border-radius: 5px;
}
.upload-list span,
.upload-list a {
  padding: 3px 10px;
}
.upload-list-left {
  /* width: ~'calc(100% - 390px)'; */
  width: 390px;
}
.upload-list-right {
  width: 130px;
}
.upload-btn-del {
  color: #fff;
  cursor: pointer;
  background: #f56c6c;
  border-radius: 3px;
  margin: 0 5px;
}
.upload-btn-down {
  color: #fff;
  cursor: pointer;
  background: #409eff;
  border-radius: 3px;
  margin: 0 5px;
}

.course-ok-btn {
  text-align: right;
  padding: 15px 0 0 0;
}
.permissions {
  margin-right: 20px;
}
.url_click {
  cursor: pointer;
  margin-bottom: 15px;
  color: #409eff;
}
/* .url_click_c{
  color: #409eff;
} */
</style>


// WEBPACK FOOTER //
// src/components/index/addClass.vue